<template>
  <v-card outline>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-card outlined>
        <v-data-table
          :headers="chargesHeaders"
          :items="charges"
          :items-per-page="-1"
          hide-default-footer
        >
          <template v-slot:item.pp="{ item }">
            {{ Number(item.pp).toFixed(2) }}
          </template>
          <template v-slot:item.total="{ item }">
            {{ Number(item.total).toFixed(2) }}
          </template>
          <template v-slot:item.compValue="{ item }">
            {{ Number(item.compValue).toFixed(2) }}
          </template>
          <template v-slot:item.adjustment="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].adjustment"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('adjustment', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.percent="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].percent"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('percent', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.foc="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].foc"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('foc', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.childrenPP="{ item }">
            {{ Number(item.childrenPP).toFixed(2) }}
          </template>
          <template v-slot:item.childTotal="{ item }">
            {{ Number(item.childTotal).toFixed(2) }}
          </template>
          <template v-slot:item.childAdjustment="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].childAdjustment"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('childAdjustment', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.childPercent="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].childPercent"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('childPercent', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.childFoc="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].childFoc"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('childFoc', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.infantsPP="{ item }">
            {{ Number(item.infantsPP).toFixed(2) }}
          </template>
          <template v-slot:item.infantTotal="{ item }">
            {{ Number(item.infantTotal).toFixed(2) }}
          </template>
          <template v-slot:item.infantAdjustment="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].infantAdjustment"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('infantAdjustment', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.infantPercent="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].infantPercent"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('infantPercent', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.infantFoc="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].infantFoc"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('infantFoc', item.occupancy)"
            ></v-text-field>
          </template>
        </v-data-table>
        <v-row justify="center">
          <span
            >Total Adults FOC Value:
            <strong>{{ totalFocValue.toFixed(2) }}</strong></span
          >, &nbsp;
          <span
            >Total Children FOC Value:
            <strong>{{ totalFocValueChildren.toFixed(2) }}</strong></span
          >, &nbsp;
          <span
            >Total Infants FOC Value:
            <strong>{{ totalFocValueInfants.toFixed(2) }}</strong></span
          >
        </v-row>
      </v-card>
      <v-container>
        <v-row justify="center">
          <v-btn text color="primary" @click="onCreateItinerary(false)">{{
            forItinerary ? "Update Itinerary" : "Create Itinerary"
          }}</v-btn>
          <v-btn
            v-if="showCreateNewIti"
            text
            color="primary"
            @click="onCreateItinerary(true)"
            >Create New Itinerary
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid px-0>
        <v-expansion-panels>
          <v-expansion-panel class="elevation-2">
            <v-expansion-panel-header>
              Services Breakdown
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <h5>Other Services:</h5>
              <v-container>
                <v-card outlined>
                  <v-data-table
                    :headers="otherHeaders"
                    :items="otherServices.filter((item) => item.isIncluded)"
                    :items-per-page="-1"
                    hide-default-footer
                  >
                    <template v-slot:item.isIncluded="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isIncluded"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                    <template v-slot:item.isOptional="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isOptional"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                    <template v-slot:item.pp="{ item }">
                      <v-tooltip right max-width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="grey lighten-1"
                              >mdi-information</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-data-table
                          :headers="otherBreakdownHeaders"
                          :items="item.breakdown"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:item.pp="{ item }">{{
                            item.pp.toFixed(2)
                          }}</template>
                          <template v-slot:item.compValue="{ item }">{{
                            item.compValue.toFixed(2)
                          }}</template>
                          <template v-slot:item.net="{ item }">{{
                            item.net.toFixed(2)
                          }}</template>
                        </v-data-table>
                      </v-tooltip>
                      {{ item.pp.toFixed(2) }}
                    </template>
                    <template v-slot:item.compValue="{ item }">{{
                      item.compValue.toFixed(2)
                    }}</template>
                    <template v-slot:item.adultNet="{ item }">{{
                      item.adultNet.toFixed(2)
                    }}</template>
                    <template v-slot:item.childrenPP="{ item }">
                      <v-tooltip right max-width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="grey lighten-1"
                              >mdi-information</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-data-table
                          :headers="
                            otherBreakdownHeaders.filter(
                              (h) => ['compValue', 'net'].indexOf(h.name) == -1
                            )
                          "
                          :items="item.breakdown"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:item.pp="{ item }">{{
                            item.childrenPP.toFixed(2)
                          }}</template></v-data-table
                        >
                      </v-tooltip>
                      {{ item.childrenPP.toFixed(2) }}
                    </template>
                    <template v-slot:item.infantsPP="{ item }">
                      <v-tooltip right max-width="300">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="grey lighten-1"
                              >mdi-information</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-data-table
                          :headers="
                            otherBreakdownHeaders.filter(
                              (h) => ['compValue', 'net'].indexOf(h.name) == -1
                            )
                          "
                          :items="item.breakdown"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:item.pp="{ item }">{{
                            item.infantsPP.toFixed(2)
                          }}</template></v-data-table
                        >
                      </v-tooltip>
                      {{ item.infantsPP.toFixed(2) }}
                    </template>
                  </v-data-table>

                  <v-row justify="center">
                    <span
                      >Total Adults:
                      <strong>{{ totalOtherServices.toFixed(2) }}</strong></span
                    >,&nbsp;
                    <span
                      >Total Children:
                      <strong>{{
                        totalOtherServicesChildren.toFixed(2)
                      }}</strong></span
                    >,&nbsp;
                    <span
                      >Total Infants:
                      <strong>{{
                        totalOtherServicesInfants.toFixed(2)
                      }}</strong></span
                    >
                  </v-row>
                </v-card>
              </v-container>
              <h5>Accommodation:</h5>
              <v-container>
                <v-card outlined>
                  <v-data-table
                    :headers="accommodationsHeaders"
                    :items="accommodationsWithComps"
                    :items-per-page="-1"
                    hide-default-footer
                    show-expand
                    item-key="name"
                  >
                    <template v-slot:expanded-item="{ item, headers }">
                      <td :colspan="headers.length">
                        <v-container fluid>
                          <v-data-table
                            :headers="allServicesHeaders"
                            :items="
                              itemsWithComps.filter(
                                (i) =>
                                  i.serviceTypeName == 'ACCOMMODATION' &&
                                  i.stdOccupancy == item.occupancy
                              )
                            "
                            :items-per-page="-1"
                            hide-default-footer
                          >
                            <template v-slot:item.isIncluded="{ item }">
                              <v-layout justify-center>
                                <v-checkbox
                                  disabled
                                  class="pa-0 ma-0"
                                  v-model="item.isIncluded"
                                  hide-details
                                ></v-checkbox>
                              </v-layout>
                            </template>
                            <template v-slot:item.isOptional="{ item }">
                              <v-layout justify-center>
                                <v-checkbox
                                  disabled
                                  class="pa-0 ma-0"
                                  v-model="item.isOptional"
                                  hide-details
                                ></v-checkbox>
                              </v-layout>
                            </template>
                          </v-data-table>
                        </v-container>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-container>

              <h5>Optional:</h5>
              <v-container>
                <v-card outlined>
                  <v-data-table
                    :headers="otherHeaders"
                    :items="
                      otherServices.filter(
                        (item) => !item.isIncluded && item.isOptional
                      )
                    "
                    :items-per-page="-1"
                    hide-default-footer
                  >
                    <template v-slot:item.isIncluded="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isIncluded"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                    <template v-slot:item.isOptional="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isOptional"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                    <template v-slot:item.pp="{ item }">
                      <v-tooltip right max-width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="grey lighten-1"
                              >mdi-information</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-data-table
                          :headers="otherBreakdownHeaders"
                          :items="item.breakdown"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:item.pp="{ item }">{{
                            item.pp.toFixed(2)
                          }}</template>
                          <template v-slot:item.compValue="{ item }">{{
                            item.compValue.toFixed(2)
                          }}</template>
                          <template v-slot:item.net="{ item }">{{
                            item.net.toFixed(2)
                          }}</template>
                        </v-data-table>
                      </v-tooltip>
                      {{ item.pp.toFixed(2) }}
                    </template>
                    <template v-slot:item.compValue="{ item }">{{
                      item.compValue.toFixed(2)
                    }}</template>
                    <template v-slot:item.adultNet="{ item }">{{
                      item.adultNet.toFixed(2)
                    }}</template>
                    <template v-slot:item.childrenPP="{ item }">
                      <v-tooltip right max-width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="grey lighten-1"
                              >mdi-information</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-data-table
                          :headers="
                            otherBreakdownHeaders.filter(
                              (h) => ['compValue', 'net'].indexOf(h.name) == -1
                            )
                          "
                          :items="item.breakdown"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:item.pp="{ item }">{{
                            item.childrenPP.toFixed(2)
                          }}</template></v-data-table
                        >
                      </v-tooltip>
                      {{ item.childrenPP.toFixed(2) }}
                    </template>
                    <template v-slot:item.infantsPP="{ item }">
                      <v-tooltip right max-width="300">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="grey lighten-1"
                              >mdi-information</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-data-table
                          :headers="
                            otherBreakdownHeaders.filter(
                              (h) => ['compValue', 'net'].indexOf(h.name) == -1
                            )
                          "
                          :items="item.breakdown"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:item.pp="{ item }">{{
                            item.infantsPP.toFixed(2)
                          }}</template></v-data-table
                        >
                      </v-tooltip>
                      {{ item.infantsPP.toFixed(2) }}
                    </template>
                  </v-data-table>

                  <v-row justify="center">
                    <span
                      >Total Adults:
                      <strong>{{ totalOtherServices.toFixed(2) }}</strong></span
                    >,&nbsp;
                    <span
                      >Total Children:
                      <strong>{{
                        totalOtherServicesChildren.toFixed(2)
                      }}</strong></span
                    >,&nbsp;
                    <span
                      >Total Infants:
                      <strong>{{
                        totalOtherServicesInfants.toFixed(2)
                      }}</strong></span
                    >
                  </v-row>
                </v-card>
                <!--
                <h5>Optional:</h5>
                <v-card outlined>
                  <v-data-table
                    :headers="allServicesHeaders"
                    :items="itemsWithComps.filter((item) => item.isOptional)"
                    :items-per-page="-1"
                    hide-default-footer
                  >
                    <template v-slot:item.isIncluded="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isIncluded"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                    <template v-slot:item.isOptional="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isOptional"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                  </v-data-table>
                </v-card>
                -->
              </v-container>
              <h5>Extras:</h5>
              <v-container>
                <v-card outlined>
                  <v-data-table :headers="extraHeaders" :items="extrasList">
                    <template v-slot:item.isOptional="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isOptional"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                    <template v-slot:item.isIncluded="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isIncluded"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                    <template v-slot:item.isChildOnly="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isChildOnly"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                    <template v-slot:item.isInfantOnly="{ item }">
                      <v-layout justify-center>
                        <v-checkbox
                          disabled
                          class="pa-0 ma-0"
                          v-model="item.isInfantOnly"
                          hide-details
                        ></v-checkbox>
                      </v-layout>
                    </template>
                  </v-data-table>
                </v-card>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
      <div v-if="debug">
        <code>---{{ charges }}</code>
        <code>{{ adjustment }}</code>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { groupByProp, removeGQLTypename, sortBy } from "../../../../../helpers";
import { ALL_RATE_TYPES_SEARCH_QUERY } from "../../../../../constants/graphql";
export default {
  name: "pax-pricing",
  props: {
    suppliersComps: {
      type: Object,
      default: () => null,
    },
    paxFrom: {
      type: Number,
      default: () => 1,
    },
    paxTo: {
      type: Number,
      default: () => 2,
    },
    items: {
      type: Array,
      default: () => [],
    },
    accommodations: {
      type: Array,
      default: () => [],
    },
    adjustment: {
      type: Object,
      default: () => null,
    },
    forItinerary: {
      type: Boolean,
      default: () => false,
    },
    showCreateNewIti: {
      type: Boolean,
      default: () => false,
    },
    paxType: {
      type: String,
      default: () => "",
    },
    percentAdjustment: {
      type: Number,
      default: () => null,
    },
    chargesHeaders: {
      type: Array,
      default: () => [
        {
          text: "Charges",
          value: "name",
          name: "name",
        },
        {
          text: "Adults PP",
          value: "pp",
          name: "pp",
        },
        {
          text: "Adults FOC",
          value: "foc",
          name: "foc",
        },
        {
          text: "Adults Adjust",
          value: "adjustment",
          name: "adjustment",
        },
        {
          text: "Adults %",
          value: "percent",
          name: "percent",
        },
        {
          text: "Adults Net",
          value: "total",
          name: "total",
        },
        {
          text: "Children PP",
          value: "childrenPP",
          name: "childrenPP",
        },
        {
          text: "Children FOC",
          value: "childFoc",
          name: "childFoc",
        },
        {
          text: "Children Adjust",
          value: "childAdjustment",
          name: "childAdjustment",
        },
        {
          text: "Children %",
          value: "childPercent",
          name: "childPercent",
        },
        {
          text: "Children Net",
          value: "childTotal",
          name: "childTotal",
        },
        {
          text: "Infants PP",
          value: "infantsPP",
          name: "infantsPP",
        },
        {
          text: "Infants FOC",
          value: "infantFoc",
          name: "infantFoc",
        },
        {
          text: "Infants Adjust",
          value: "infantAdjustment",
          name: "infantAdjustment",
        },
        {
          text: "Infants %",
          value: "infantPercent",
          name: "infantPercent",
        },
        {
          text: "Infants Net",
          value: "infantTotal",
          name: "infantTotal",
        },
      ],
    },
  },

  data() {
    return {
      debug: false,
      accommodationsHeaders: [
        {
          text: "Room Type",
          value: "name",
          name: "name",
        },
        {
          text: "Adult PP",
          value: "pp",
          name: "pp",
        },
        {
          text: "Comp Value",
          value: "compValue",
          name: "compValue",
        },
        {
          text: "Child PP",
          value: "childrenPP",
          name: "childrenPP",
        },
        {
          text: "Infant PP",
          value: "infantsPP",
          name: "infantsPP",
        },
      ],
      otherHeaders: [
        {
          text: "Supplier",
          value: "supplierName",
          name: "supplierName",
        },
        {
          text: "Service",
          value: "name",
          name: "name",
        },
        {
          text: "Adult PP",
          value: "pp",
          name: "pp",
        },
        {
          text: "Comp Value",
          value: "compValue",
          name: "compValue",
        },
        {
          text: "Adult Net",
          value: "adultNet",
          name: "adultNet",
        },
        {
          text: "Child PP",
          value: "childrenPP",
          name: "childrenPP",
        },
        {
          text: "Infant PP",
          value: "infantsPP",
          name: "infantsPP",
        },
        {
          text: "Included",
          value: "isIncluded",
          name: "isIncluded",
        },
        {
          text: "Optional",
          value: "isOptional",
          name: "isOptional",
        },
      ],
      otherBreakdownHeaders: [
        {
          text: "Pax",
          value: "pax",
          name: "pax",
        },
        {
          text: "Qty",
          value: "qty",
          name: "qty",
        },
        {
          text: "PP",
          value: "pp",
          name: "pp",
        },
        {
          text: "Comp Value",
          value: "compValue",
          name: "compValue",
        },
        {
          text: "Net",
          value: "net",
          name: "net",
        },
      ],
      extraHeaders: [
        {
          text: "Supplier",
          value: "supplierName",
          name: "supplierName",
        },
        {
          text: "Service",
          value: "serviceName",
          name: "serviceName",
        },
        {
          text: "Extra",
          value: "name",
          name: "name",
        },
        {
          text: "Price",
          value: "price",
          name: "price",
        },
        {
          text: "Child Price",
          value: "childPrice",
          name: "childPrice",
        },
        {
          text: "Infant Price",
          value: "infantPrice",
          name: "infantPrice",
        },
        {
          text: "Included",
          value: "isIncluded",
          name: "isIncluded",
          align: "center",
        },
        {
          text: "Optional",
          value: "isOptional",
          name: "isOptional",
          align: "center",
        },
        {
          text: "Is Child Only",
          value: "isChildOnly",
          name: "isChildOnly",
          align: "center",
        },
        {
          text: "Is Infant Only",
          value: "isInfantOnly",
          name: "isInfantOnly",
          align: "center",
        },
      ],
      chargesData: {
        1: {
          adjustment: this.adjustment ? Number(this.adjustment.adjustment1) : 0,
          foc: this.adjustment ? Number(this.adjustment.foc1) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment1)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc1) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment1)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc1) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
        2: {
          adjustment: this.adjustment ? Number(this.adjustment.adjustment2) : 0,
          foc: this.adjustment ? Number(this.adjustment.foc2) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment2)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc2) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment2)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc2) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
        3: {
          adjustment: this.adjustment ? Number(this.adjustment.adjustment3) : 0,
          foc: this.adjustment ? Number(this.adjustment.foc3) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment3)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc3) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment3)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc3) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
        4: {
          adjustment: this.adjustment ? Number(this.adjustment.adjustment4) : 0,
          foc: this.adjustment ? Number(this.adjustment.foc4) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment4)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc4) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment4)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc4) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
        100: {
          adjustment: this.adjustment
            ? Number(this.adjustment.adjustment100)
            : 0,
          foc: this.adjustment ? Number(this.adjustment.foc100) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment100)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc100) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment100)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc100) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
      },
      allServicesHeaders: [
        {
          text: "Supplier",
          value: "supplierName",
          name: "supplierName",
        },
        {
          text: "Service",
          value: "serviceName",
          name: "serviceName",
        },
        {
          text: "Adult PP",
          value: "price",
          name: "price",
        },
        {
          text: "Child PP",
          value: "childrenPrice",
          name: "childrenPrice",
        },
        {
          text: "Infant PP",
          value: "infantsPrice",
          name: "infantsPrice",
        },
        {
          text: "Comp Value",
          value: "compValue",
          name: "compValue",
        },
        {
          text: "Included",
          value: "isIncluded",
          name: "isIncluded",
        },
        {
          text: "Optional",
          value: "isOptional",
          name: "isOptional",
        },
      ],
    };
  },

  computed: {
    extrasList() {
      return this.items.reduce((extras, item) => {
        if (item.extras && item.extras.length > 0) {
          for (const extra of item.extras) {
            extras.push(extra);
          }
        }
        return extras;
      }, []);
    },
    accommodationsWithComps() {
      const roomTypes = {
        1: "Single",
        2: "Double/Twin",
        3: "Triple",
        4: "Quad",
        100: "Multi Bed",
      };
      const byRoomType = groupByProp(
        this.itemsWithComps.filter(
          (item) => item.serviceTypeName == "ACCOMMODATION" && item.isIncluded
        ),
        "stdOccupancy"
      );
      return Object.keys(byRoomType).reduce((rooms, occupancy) => {
        rooms.push({
          name: roomTypes[occupancy],
          occupancy,
          pp: byRoomType[occupancy].reduce(
            (sum, item) => sum + Number(item.price),
            0
          ),
          compValue: Number(
            byRoomType[occupancy].reduce(
              (sum, item) => sum + Number(item.compValue),
              0
            )
          ).toFixed(2),
          childrenPP: byRoomType[occupancy].reduce(
            (sum, item) => sum + Number(item.childrenPrice),
            0
          ),
          infantsPP: byRoomType[occupancy].reduce(
            (sum, item) => sum + Number(item.infantsPrice),
            0
          ),
        });

        return rooms;
      }, []);
    },
    itemsWithComps() {
      return this.items.map((item) => {
        let comp = null;
        let compValue = 0;
        const rateType = this.rateTypes
          ? this.rateTypes.edges
              .map(removeGQLTypename)
              .find((r) => r.code == item.rateType)
          : null;
        //console.log(rateType, item);
        if (this.suppliersComps[item.supplierId]) {
          comp = this.suppliersComps[item.supplierId].find(
            (comp) =>
              this.paxFrom >= comp.paxFrom &&
              this.paxFrom <= comp.paxTo &&
              item.serviceId == comp.service.id
          );
          if (comp) {
            if (
              rateType &&
              !rateType.includePax &&
              item.serviceTypeName == "ACCOMMODATION"
            ) {
              //multiply pp price by occupancy to get unit price
              compValue =
                (item.price * item.stdOccupancy * comp.pass) / this.paxTo;
            } else {
              compValue = (item.price * comp.pass) / this.paxTo;
            }
          }
        }
        return { ...item, compValue, comp };
      });
    },
    charges() {
      const totalFocValue =
        this.totalFocValue +
        this.totalFocValueChildren +
        this.totalFocValueInfants;
      // const focValuePerPax = totalFocValue / this.paxFrom;
      //console.log("foceValueperpax", totalFocValue, focValuePerPax);
      const totalFOC = this.totalFocNumber;
      return this.accommodationsWithComps.map((a) => {
        // const totalFOC =
        //   this.chargesData[a.occupancy].foc +
        //   this.chargesData[a.occupancy].childFoc +
        //   this.chargesData[a.occupancy].infantFoc;
        const focValuePerPax = totalFocValue / (this.paxFrom - totalFOC);
        //totalFOC != 0 ? totalFocValue / (this.paxFrom - totalFOC) : 0;
        // console.log("totalFocValue => ", totalFocValue);
        // console.log(
        //   Number(a.pp) +
        //     Number(this.totalOtherServices) +
        //     // Number(this.totalFocValue) +
        //     Number(focValuePerPax) +
        //     Number(this.chargesData[a.occupancy].adjustment)
        // );

        const compValue =
          (Number(this.totalAccommodationsServicesCompValue) +
            Number(this.totalOtherServicesCompValue)) *
          -1;
        //const compValue = 0;
        return {
          name: a.name,
          pp: a.pp + this.totalOtherServices,
          compValue,
          childrenPP: a.childrenPP + this.totalOtherServicesChildren,
          infantsPP: a.infantsPP + this.totalOtherServicesInfants,
          childFoc: this.chargesData[a.occupancy].childFoc,
          infantFoc: this.chargesData[a.occupancy].infantFoc,
          adjustment: this.chargesData[a.occupancy].adjustment,
          childAdjustment: this.chargesData[a.occupancy].childAdjustment,
          infantAdjustment: this.chargesData[a.occupancy].infantAdjustment,

          foc: this.chargesData[a.occupancy].foc,
          total:
            Number(a.pp) +
            Number(this.totalOtherServices) +
            // Number(this.totalFocValue) +
            Number(focValuePerPax) +
            Number(this.chargesData[a.occupancy].adjustment) +
            compValue,
          childTotal:
            Number(a.childrenPP) +
            Number(this.totalOtherServicesChildren) +
            //Number(this.totalFocValueChildren) +
            Number(focValuePerPax) +
            Number(this.chargesData[a.occupancy].childAdjustment) +
            compValue,
          infantTotal:
            Number(a.infantsPP) +
            Number(this.totalOtherServicesInfants) +
            //Number(this.totalFocValueInfants) +
            //exclude infants foc
            //Number(focValuePerPax) +
            Number(this.chargesData[a.occupancy].infantAdjustment) +
            compValue,
          occupancy: a.occupancy,
          percent: this.chargesData[a.occupancy].percent,
          childPercent: this.chargesData[a.occupancy].childPercent,
          infantPercent: this.chargesData[a.occupancy].infantPercent,
        };
      });
    },
    totalFocNumber() {
      return this.accommodations.reduce(
        (sum, a) =>
          sum +
          Number(this.chargesData[a.occupancy].foc) +
          Number(this.chargesData[a.occupancy].childFoc), //+Number(this.chargesData[a.occupancy].infantFoc),
        // /(Number(this.paxFrom) - Number(this.chargesData[a.occupancy].foc)),
        0
      );
    },
    totalFocValue() {
      return this.accommodations.reduce(
        (sum, a) =>
          sum +
          (Number(a.pp) + Number(this.totalOtherServices)) *
            Number(this.chargesData[a.occupancy].foc),
        // /(Number(this.paxFrom) - Number(this.chargesData[a.occupancy].foc)),
        0
      );
    },
    totalFocValueChildren() {
      return this.accommodations.reduce(
        (sum, a) =>
          sum +
          (Number(a.childrenPP) + Number(this.totalOtherServicesChildren)) *
            Number(this.chargesData[a.occupancy].childFoc), ///(Number(this.paxFrom) - Number(this.chargesData[a.occupancy].childFoc))
        0
      );
    },
    totalFocValueInfants() {
      return this.accommodations.reduce(
        (sum, a) =>
          sum +
          (Number(a.infantsPP) + Number(this.totalOtherServicesInfants)) *
            Number(this.chargesData[a.occupancy].infantFoc), //(Number(this.paxFrom) - Number(this.chargesData[a.occupancy].infantFoc)),
        0
      );
    },
    totalOtherServices() {
      return this.otherServices
        .filter((item) => item.isIncluded)
        .reduce((sum, item) => sum + Number(item.pp), 0);
    },
    totalOtherServicesCompValue() {
      return this.otherServices
        .filter((item) => item.isIncluded)
        .reduce((sum, item) => sum + Number(item.compValue), 0);
    },
    totalAccommodationsServicesCompValue() {
      return this.accommodationsWithComps.reduce(
        (sum, item) => sum + Number(item.compValue),
        0
      );
    },
    totalOtherServicesChildren() {
      return this.otherServices
        .filter((item) => item.isIncluded)
        .reduce((sum, item) => sum + Number(item.childrenPP), 0);
    },
    totalOtherServicesInfants() {
      return this.otherServices
        .filter((item) => item.isIncluded)
        .reduce((sum, item) => sum + Number(item.infantsPP), 0);
    },
    otherServices() {
      return this.itemsWithComps
        .filter((item) => item.serviceTypeName != "ACCOMMODATION")
        .map((item) => {
          const breakdown = [];
          const rateType = this.rateTypes
            ? this.rateTypes.edges
                .map(removeGQLTypename)
                .find((r) => r.code == item.rateType)
            : null;
          for (let i = this.paxFrom; i <= this.paxTo; i++) {
            const qty = Math.ceil(i / Number(item.stdOccupancy));
            let comp = null;
            if (this.suppliersComps[item.supplierId]) {
              comp = this.suppliersComps[item.supplierId].find(
                (comp) =>
                  this.paxFrom >= comp.paxFrom &&
                  this.paxFrom <= comp.paxTo &&
                  item.serviceId == comp.service.id
              );
            }
            const pp =
              rateType && rateType.includePax
                ? Number(item.price)
                : (qty * Number(item.price)) / i;
            const compValue = comp ? (item.price * comp.pass) / i : 0;
            const net = pp - compValue;

            breakdown.push({
              pax: i,
              qty,
              pp,
              net,
              childrenPP:
                rateType && rateType.includePax
                  ? Number(item.childrenPrice)
                  : (qty * Number(item.childrenPrice)) / i,
              infantsPP:
                rateType && rateType.includePax
                  ? Number(item.infantsPrice)
                  : (qty * Number(item.infantsPrice)) / i,
              compValue,
            });
          }
          const highestPriced = breakdown.sort(sortBy("pp"))[
            breakdown.length - 1
          ];
          const pp = highestPriced["pp"];
          const compValue = highestPriced["compValue"];
          // const compValue = item.comp
          //   ? rateType && rateType.includeQuantity
          //     ? item.compValue
          //     : (pp * item.comp.pass) / this.paxTo
          //   : 0;
          const adultNet = pp - compValue;
          return {
            name: `${item.serviceName}`,
            supplierName: item.supplierName,
            breakdown,
            pp,
            adultNet,
            childrenPP: breakdown.sort(sortBy("childrenPP"))[
              breakdown.length - 1
            ]["childrenPP"],
            infantsPP: breakdown.sort(sortBy("infantsPP"))[
              breakdown.length - 1
            ]["infantsPP"],
            compValue,
            total: pp - compValue,
            isIncluded: item.isIncluded,
            isOptional: item.isOptional,
          };
        });
    },
    title() {
      return `Pax From: ${this.paxFrom}, Pax To: ${this.paxTo}`;
    },
  },

  watch: {
    percentAdjustment(newVal) {
      const occupancyNumbers = [1, 2, 3, 4, 100];
      for (const i of occupancyNumbers) {
        this.chargesData[i].percent = newVal;
        this.onChargesDataChange("percent", i.toString());
        this.chargesData[i].childPercent = newVal;
        this.onChargesDataChange("childPercent", i.toString());
        this.chargesData[i].infantPercent = newVal;
        this.onChargesDataChange("infantPercent", i.toString());
      }
    },
    adjustment(newVal) {
      this.chargesData = {
        1: {
          adjustment: this.adjustment ? Number(this.adjustment.adjustment1) : 0,
          foc: this.adjustment ? Number(this.adjustment.foc1) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment1)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc1) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment1)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc1) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
        2: {
          adjustment: this.adjustment ? Number(this.adjustment.adjustment2) : 0,
          foc: this.adjustment ? Number(this.adjustment.foc2) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment2)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc2) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment2)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc2) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
        3: {
          adjustment: this.adjustment ? Number(this.adjustment.adjustment3) : 0,
          foc: this.adjustment ? Number(this.adjustment.foc3) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment3)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc3) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment3)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc3) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
        4: {
          adjustment: this.adjustment ? Number(this.adjustment.adjustment4) : 0,
          foc: this.adjustment ? Number(this.adjustment.foc4) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment4)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc4) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment4)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc4) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
        100: {
          adjustment: this.adjustment
            ? Number(this.adjustment.adjustment100)
            : 0,
          foc: this.adjustment ? Number(this.adjustment.foc100) : 0,
          childAdjustment: this.adjustment
            ? Number(this.adjustment.childAdjustment100)
            : 0,
          childFoc: this.adjustment ? Number(this.adjustment.childFoc100) : 0,
          infantAdjustment: this.adjustment
            ? Number(this.adjustment.infantAdjustment100)
            : 0,
          infantFoc: this.adjustment ? Number(this.adjustment.infantFoc100) : 0,
          percent: null,
          childPercent: null,
          infantPercent: null,
        },
      };
    },
    charges(newVal) {
      const occupancyNumbers = [1, 2, 3, 4, 100];
      for (const i of occupancyNumbers) {
        if (!this.chargesData[i].percent) {
          const charge = this.charges.find((c) => c.occupancy == i);
          if (charge && charge.adjustment) {
            this.chargesData[i].percent = (
              (charge.adjustment / charge.pp) *
              100
            ).toFixed(2);
          }
        }
        if (!this.chargesData[i].childPercent) {
          const charge = this.charges.find((c) => c.occupancy == i);
          if (charge && charge.childAdjustment) {
            this.chargesData[i].childPercent = (
              (charge.childAdjustment / charge.childrenPP) *
              100
            ).toFixed(2);
          }
        }
        if (!this.chargesData[i].infantPercent) {
          const charge = this.charges.find((c) => c.occupancy == i);
          if (charge && charge.infantAdjustment) {
            this.chargesData[i].infantPercent = (
              (charge.infantAdjustment / charge.infantsPP) *
              100
            ).toFixed(2);
          }
        }
      }
      //update adjustement with  pp prices
      const adjustment = {
        ...this.adjustment,
        paxFrom: this.paxFrom,
        paxTo: this.paxTo,
      };

      for (const i of occupancyNumbers) {
        const charge = this.charges.find((c) => c.occupancy == i);

        for (const paxType of ["adult", "child", "infant"]) {
          if (charge) {
            adjustment[`${paxType}Total${i}`] =
              paxType == "adult" ? charge.total : charge[`${paxType}Total`];
          } else {
            adjustment[`${paxType}Total${i}`] = 0;
          }
        }
      }
      this.$emit("change", adjustment);
    },
  },

  methods: {
    onCreateItinerary(createNew) {
      this.$emit("create-itinerary", {
        charges: [...this.charges],
        paxFrom: this.paxFrom,
        paxTo: this.paxTo,
        createNew,
      });
    },
    onChargesDataChange(f, i) {
      //console.log(f, i);
      if (f == "percent") {
        //update adjustment
        const percent = Number(this.chargesData[i].percent) / 100;
        const ppForCharge = this.charges.find((c) => c.occupancy == i);
        if (ppForCharge) {
          this.chargesData[i].adjustment = (
            Number(ppForCharge.pp) * percent
          ).toFixed(2);
        }
      } else if (f == "childPercent") {
        //update adjustment
        const percent = Number(this.chargesData[i].childPercent) / 100;
        const ppForCharge = this.charges.find((c) => c.occupancy == i);
        if (ppForCharge) {
          this.chargesData[i].childAdjustment = (
            Number(ppForCharge.childrenPP) * percent
          ).toFixed(2);
        }
      } else if (f == "infantPercent") {
        const percent = Number(this.chargesData[i].infantPercent) / 100;
        const ppForCharge = this.charges.find((c) => c.occupancy == i);
        if (ppForCharge) {
          this.chargesData[i].infantAdjustment = (
            Number(ppForCharge.infantsPP) * percent
          ).toFixed(2);
        }
      } else if (f == "adjustment") {
        const adjustment = Number(this.chargesData[i].adjustment);
        const ppForCharge = this.charges.find((c) => c.occupancy == i).pp;
        this.chargesData[i].percent = (
          (adjustment / ppForCharge) *
          100
        ).toFixed(2);
      } else if (f == "childAdjustment") {
        const adjustment = Number(this.chargesData[i].childAdjustment);
        const ppForCharge = this.charges.find(
          (c) => c.occupancy == i
        ).childrenPP;
        this.chargesData[i].childPercent = (
          (adjustment / ppForCharge) *
          100
        ).toFixed(2);
      } else if (f == "infantAdjustment") {
        const adjustment = Number(this.chargesData[i].infantAdjustment);
        const ppForCharge = this.charges.find(
          (c) => c.occupancy == i
        ).infantsPP;
        this.chargesData[i].infantPercent = (
          (adjustment / ppForCharge) *
          100
        ).toFixed(2);
      }
      //this.chargesData = [...this.chargesData];
      this.$emit("change", {
        paxFrom: this.paxFrom,
        paxTo: this.paxTo,
        adjustment1: Number(this.chargesData[1].adjustment),
        adjustment2: Number(this.chargesData[2].adjustment),
        adjustment3: Number(this.chargesData[3].adjustment),
        adjustment4: Number(this.chargesData[4].adjustment),
        adjustment100: Number(this.chargesData[100].adjustment),
        foc1: Number(this.chargesData[1].foc),
        foc2: Number(this.chargesData[2].foc),
        foc3: Number(this.chargesData[3].foc),
        foc4: Number(this.chargesData[4].foc),
        foc100: Number(this.chargesData[100].foc),
        childAdjustment1: Number(this.chargesData[1].childAdjustment),
        childAdjustment2: Number(this.chargesData[2].childAdjustment),
        childAdjustment3: Number(this.chargesData[3].childAdjustment),
        childAdjustment4: Number(this.chargesData[4].childAdjustment),
        childAdjustment100: Number(this.chargesData[100].childAdjustment),
        childFoc1: Number(this.chargesData[1].childFoc),
        childFoc2: Number(this.chargesData[2].childFoc),
        childFoc3: Number(this.chargesData[3].childFoc),
        childFoc4: Number(this.chargesData[4].childFoc),
        childFoc100: Number(this.chargesData[100].childFoc),
        infantAdjustment1: Number(this.chargesData[1].infantAdjustment),
        infantAdjustment2: Number(this.chargesData[2].infantAdjustment),
        infantAdjustment3: Number(this.chargesData[3].infantAdjustment),
        infantAdjustment4: Number(this.chargesData[4].infantAdjustment),
        infantAdjustment100: Number(this.chargesData[100].infantAdjustment),
        infantFoc1: Number(this.chargesData[1].infantFoc),
        infantFoc2: Number(this.chargesData[2].infantFoc),
        infantFoc3: Number(this.chargesData[3].infantFoc),
        infantFoc4: Number(this.chargesData[4].infantFoc),
        infantFoc100: Number(this.chargesData[100].infantFoc),
      });
    },
    getAdjustment(no) {
      const paxMap = {
        adults: "adjustment",
        children: "childAdjustment",
        infants: "infantAdjustment",
      };
      const f = paxMap[this.paxType];
      return this.adjustment[`${f}${no}`];
    },
    getFoc(no) {
      const paxMap = {
        adults: "foc",
        children: "childFoc",
        infants: "infantFoc",
      };
      const f = paxMap[this.paxType];
      return this.adjustment[`${f}${no}`];
    },
  },

  apollo: {
    rateTypes: {
      query: ALL_RATE_TYPES_SEARCH_QUERY,
    },
  },
};
</script>

<style scoped>
.short-input {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/increments/PaxPricingCombined.vue